<script>
  import { createEventDispatcher } from 'svelte';
  import Select from 'svelte-select';

  export let categories;

  const dispatch = createEventDispatcher();

	function handleSelect({ detail: category }) {
    dispatch('change', { categoryId: category.id });
	}
</script>

<Select 
  optionIdentifier="id" 
  getSelectionLabel={cat => cat.name} 
  getOptionLabel={cat => cat.name} 
  items={categories} 
  on:clear
  on:select={handleSelect} 
  placeholder="Seleccione una categoría"
/>